namespace GeniuzPOS.Purchase {
    export namespace PoPurRequestService {
        export const baseUrl = 'Purchase/PoPurRequest';

        export declare function Create(request: Serenity.SaveRequest<PoPurRequestRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoPurRequestRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoPurRequestRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoPurRequestRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UpdateCancelAndUseFg(request: UpdateCancelAndUseFgRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoPurRequest/Create",
            Update = "Purchase/PoPurRequest/Update",
            Delete = "Purchase/PoPurRequest/Delete",
            GetNextNumber = "Purchase/PoPurRequest/GetNextNumber",
            Retrieve = "Purchase/PoPurRequest/Retrieve",
            List = "Purchase/PoPurRequest/List",
            UpdateCancelAndUseFg = "Purchase/PoPurRequest/UpdateCancelAndUseFg"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'GetNextNumber', 
            'Retrieve', 
            'List', 
            'UpdateCancelAndUseFg'
        ].forEach(x => {
            (<any>PoPurRequestService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
